import { Locales } from "../../helper/Locales.js";
export const Format = ({
  language = 'de',
  variant = 'decimal',
  decimalPlaces = 2,
  children
}) => {
  const locale = Locales[language].isoCodes.language;
  const style = variant === 'percentage' ? 'percent' : variant;
  const currency = style === 'currency' ? Locales[language].isoCodes.currency : undefined;
  let input = typeof children === 'string' ? Number.parseFloat(children) : children;

  // Force existing pattern (1 -> 1%, not 1 -> 100%)
  if (style === 'percent') {
    input *= 0.01;
  }
  return new Intl.NumberFormat(locale, {
    style,
    currency,
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  }).format(input);
};